// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-business-attribute-attrViews-AttrViewFiles-AttrViewFiles-module__name--xX_wh {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
/*# sourceMappingURL=AttrViewFiles.module.css.map */`, "",{"version":3,"sources":["webpack://./AttrViewFiles.module.less","webpack://./src/business/attribute/attrViews/AttrViewFiles/AttrViewFiles.module.less"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;ACCF;AACA,mDAAmD","sourcesContent":[".name {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n",".name {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n/*# sourceMappingURL=AttrViewFiles.module.css.map */"],"sourceRoot":""}]);
// Exports
export var name = `src-business-attribute-attrViews-AttrViewFiles-AttrViewFiles-module__name--xX_wh`;
export default ___CSS_LOADER_EXPORT___;
